//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================
// material-ui
import { makeStyles } from "@material-ui/core/styles";

export const loaderStyles = makeStyles({
    root: {
      verticalAlign: "middle",
      marginTop: 0,
      color: "#4472c4",
    },
    mainDiv: {
      textAlign: "center",
    },
  });